import { HTMLAttributeAnchorTarget } from 'react';
import NextLink from 'next/link';
import cx from 'classnames';

import { useTailwind } from '@/hooks/useTailwind';

interface LinkProps {
    href?: string;
    className?: string;
    target?: HTMLAttributeAnchorTarget;
    style?: React.CSSProperties;
    children: React.ReactNode;
}

const Link = ({ href = '#', className = '', target = '_self', children, ...rest }: LinkProps) => {
    const tw = useTailwind(className);

    return (
        <NextLink prefetch={true} href={href} target={target} className={cx('w-fit inline-flex items-center font-medium', {
            'text-lg sm:text-xl': ! tw.hasTextSize(),
            'text-primary-500': ! tw.hasTextColor(),
            [className]: Boolean(className)
        })} {...rest}>
            {children}
        </NextLink>
    );
};

export { Link };